import React from "react";
import styled from "styled-components";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import ToastProvider from "../commons/Toast";
import { dark } from "../constants/styles";

// Focused exam shell — keeps the global Header/Footer for brand
// consistency but renders without the sub-navigation strips and
// search bars to reduce mid-exam distraction. Sets [data-theme] for
// dark-mode parity with the rest of the rebrand.
export default function ExamApp({ theme = "light", children }) {
  const resolved = theme === "dark" ? "dark" : "light";

  React.useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolved);
    return () => document.documentElement.removeAttribute("data-theme");
  }, [resolved]);

  return (
    <ToastProvider>
      <Page data-theme={resolved}>
        <Header />
        <Body>{children}</Body>
        <Footer />
      </Page>
    </ToastProvider>
  );
}

const Page = styled.div`
  background: #f9fafb;
  min-height: 100vh;
  color: #1f2937;
  font-family: "Montserrat", sans-serif;

  &[data-theme="dark"] {
    background: ${dark.page_bg};
    color: ${dark.text_primary};
  }
`;

const Body = styled.main`
  padding: 32px 0 64px;

  @media (max-width: 1023px) {
    padding: 24px 0 48px;
  }
`;
